import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import ArchiveLayout from './ArchiveLayout'
import Materials from './Materials'

const ArchiveLayoutMaterials = ({
  data: { contentfulArchive, allContentfulMaterial },
}) => {
  return (
    <ArchiveLayout
      title={get(contentfulArchive, 'hero.title')}
      focalComponent={
        <Accessa.Partials.Blanket
          {...get(contentfulArchive, 'hero.image')}
          style={{
            backgroundColor: '#b0c3ad',
          }}
        />
      }
    >
      <Materials
        // eslint-disable-next-line
        json={contentfulArchive?.description?.json}
        materials={allContentfulMaterial.nodes}
      />
    </ArchiveLayout>
  )
}

ArchiveLayoutMaterials.propTypes = {
  data: PropTypes.shape({
    contentfulArchive: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      hero: PropTypes.object,
    }).isRequired,
    allContentfulMaterial: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          // eslint-disable-next-line react/forbid-prop-types
          categories: PropTypes.any,
        })
      ).isRequired,
    }),
  }).isRequired,
}

export default ArchiveLayoutMaterials
